  /**
   * پاک‌ساز HTML خوداتکا → HTML خام ادیتور
   *
   * محتوای ذخیره‌شده در دیتابیس «self-contained» است:
   *   <div class="exam-question-content">
   *     <style data-exam-styles> ... کل CSS کاتکس و استایل سوال ... </style>
   *     <p>متن <span class="math-formula-container" data-type="fraction"
   *          num="2" den="3123" data-latex="\dfrac{2}{3123}" data-rendered="true">
   *          ...خروجی رندرشده KaTeX... </span> ...</p>
   *     <span class="math-expression-wrap" dir="ltr"> ... گروه‌بندی LTR ... </span>
   *   </div>
   *
   * برای ویرایش مجدد در Tiptap باید:
   *   ۱) بلوک <style data-exam-styles> حذف شود (ادیتور به آن نیاز ندارد)
   *   ۲) data-rendered و خروجی رندرشده KaTeX از داخل فرمول‌ها پاک شود —
   *      فقط span[data-type] با اتریبیوت‌های فیلد (num/den/radicand/...)
   *      بماند تا parseHTML اکستنشن‌ها NodeView تعاملی بسازند
   *   ۳) wrapper های math-expression-wrap باز شوند (مارک mathExpr خودش دوباره می‌سازد)
   *   ۴) wrapper تصاویر exam-image-wrapper — parseHTML تصویر خودش می‌خواندش، دست نمی‌زنیم
   *   ۵) ارقام فارسی به لاتین برگردند (ادیتور با لاتین کار می‌کند؛ خروجی نهایی دوباره فارسی می‌شود)
   *   ۶) DOMPurify دو بار اجرا نشود — اینجا فقط DOM manipulation است
   */

  /**
   * ارقام فارسی/عربی → لاتین (برعکسِ کاری که رندر نهایی می‌کند)
   */
  const toLatinDigits = (str) =>
    String(str).replace(/[۰-۹٠-٩]/g, (d) => {
      const code = d.charCodeAt(0);
      return String.fromCharCode(code - (code >= 0x06f0 ? 1728 : 1632));
    });

  export const unwrapSelfContainedHtml = (html) => {
    if (typeof document === "undefined" || !html) return html || "";

    const host = document.createElement("div");
    host.innerHTML = html;

    // اگر خروجی self-contained نبود (HTML خام ادیتور بود) → همان را برگردان
    if (
      !host.querySelector("style[data-exam-styles]") &&
      !host.querySelector(".exam-question-content") &&
      !host.querySelector(
        ".math-formula-container[data-rendered], span[data-type][data-latex]",
      )
    ) {
      return html;
    }

    // ۱) حذف استایل‌های self-contained
    host.querySelectorAll("style[data-exam-styles]").forEach((el) => el.remove());

    // باز کردن و حذف کانتینرهای .exam-question-content
    host.querySelectorAll(".exam-question-content").forEach((wrap) => {
      const parent = wrap.parentNode;
      if (!parent) return;
      while (wrap.firstChild) parent.insertBefore(wrap.firstChild, wrap);
      parent.removeChild(wrap);
    });

    // ۲) باز کردن wrapper های گروه‌بندی ریاضی (فرزندانش به جای خودشان می‌نشینند)
    host.querySelectorAll("span.math-expression-wrap").forEach((wrap) => {
      const parent = wrap.parentNode;
      if (!parent) return;
      while (wrap.firstChild) parent.insertBefore(wrap.firstChild, wrap);
      parent.removeChild(wrap);
    });

    // ۳) پاکسازی فرمول‌ها: هر span[data-type] فقط با اتریبیوت‌های فیلدش می‌ماند
    //    (نمونه واقعی: num="2" den="3123" — parseHTML اکستنشن اتریبیوت خام را می‌خواند)
    host.querySelectorAll("span[data-type][data-latex]").forEach((el) => {
      el.classList.remove("math-formula-container");
      el.classList.remove("inline-formula-static");
      el.removeAttribute("data-rendered");
      el.removeAttribute("style");
      el.removeAttribute("dir");
      // خروجی رندرشده KaTeX دور ریخته می‌شود — اکستنشن NodeView خودش می‌سازد
      el.innerHTML = "";
    });

    // ۴) ارقام فارسی → لاتین (فقط خارج از هیچ فرمولی — چون فرمول‌ها الان خالی‌اند)
    const walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let textNode;
    while ((textNode = walker.nextNode())) textNodes.push(textNode);
    textNodes.forEach((tn) => {
      if (/[۰-۹٠-٩]/.test(tn.nodeValue)) {
        tn.nodeValue = toLatinDigits(tn.nodeValue);
      }
    });

    return host.innerHTML;
  };

  export default unwrapSelfContainedHtml;
